import { getHotkeyMenu, HOTKEY_TYPE, useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ activeLayer }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();

    if (!activeLayer) return null;

    const item = {
        disabled: !framework.checkIsExtraGroup(activeLayer),
        name: $t((v) => v.contextMenuLayer.menuConfig.makeGroup),
        type: HOTKEY_TYPE.makeGroup,
        desc: getHotkeyMenu(HOTKEY_TYPE.makeGroup),
        onClick: () => {
            framework.events.emit(HOTKEY_TYPE.makeGroup);
        },
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 2,
    sort: 1,
    render,
} as IExportContextMenuItem;
